import React from "react";
import photo1 from "../../Assets/Images/landing/hero-a.jpg";
import photo2 from "../../Assets/Images/landing/hero-b.jpg";
import photo3 from "../../Assets/Images/landing/hero-c.jpg";
import photo4 from "../../Assets/Images/landing/hero-d.jpg";

const steps = [
  { n: "01", title: "Upload photos", body: "Drop a folder or pick a batch from your phone. High-res files are processed right in your browser." },
  { n: "02", title: "Design your watermark", body: "Add logo, text, or a hand signature. Adjust opacity, size, rotation and position with a live preview." },
  { n: "03", title: "Save as template", body: "Store your watermark as a template. Reuse it on any device just by logging in — no re-setup." },
  { n: "04", title: "Export in one click", body: "Batch export at original quality. EXIF and color profiles are preserved on every image." },
];

const StepVisual: React.FC<{ i: number }> = ({ i }) => {
  if (i === 0) {
    return (
      <div className="lr-howto__visual">
        <div className="lr-drop-tray">
          <div />
        </div>
        {[photo1, photo2, photo3].map((p, idx) => (
          <img
            key={idx}
            src={p}
            alt=""
            className="lr-drop-photo"
            style={{ animationDelay: `${idx * 0.6}s`, zIndex: 3 - idx }}
          />
        ))}
      </div>
    );
  }
  if (i === 1) {
    return (
      <div className="lr-howto__visual">
        <div className="lr-howto-design">
          <img src={photo4} alt="" />
          <div className="lr-howto-design__scrim" />
          <div className="lr-howto-design__mark">© eZy</div>
          <div className="lr-howto-design__dots">
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    );
  }
  if (i === 2) {
    return (
      <div className="lr-howto__visual">
        <div className="lr-howto-template">
          {[0, 1, 2].map((k) => (
            <div key={k} className="lr-howto-template__card" style={{ animationDelay: `${k * 0.4}s`, zIndex: 3 - k }}>
              <div className="lr-howto-template__card-bar1" />
              <div className="lr-howto-template__card-bar2" />
              <div className="lr-howto-template__card-bar3" />
            </div>
          ))}
          <div className="lr-howto-template__check">✓</div>
        </div>
      </div>
    );
  }
  return (
    <div className="lr-howto__visual">
      <div className="lr-howto-export">
        <div className="lr-howto-export__arrow">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3v14" /><path d="m6 13 6 6 6-6" />
          </svg>
        </div>
        <div className="lr-howto-export__bar">
          <div />
        </div>
        <div className="lr-howto-export__label">EXPORTING…</div>
      </div>
    </div>
  );
};

const HowTo: React.FC = () => {
  return (
    <section id="howto" className="lr-section">
      <div className="lr-section__inner lr-howto">
        <div style={{ textAlign: "center", marginBottom: "3.5em" }}>
          <span className="lr-section__eyebrow">How to add</span>
          <h2 className="lr-section__heading" style={{ maxWidth: "none", marginTop: "0.375em" }}>
            Watermark in four easy steps.
          </h2>
        </div>
        <div className="lr-howto__grid">
          {steps.map((s, i) => (
            <div key={s.n} className="lr-howto__card">
              <StepVisual i={i} />
              <div className="lr-howto__num">{s.n}</div>
              <h3 className="lr-howto__title">{s.title}</h3>
              <p className="lr-howto__body">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowTo;
